<template class="full-height">
  <div class="view-point-app-container" style="position: relative; height: 100%; padding: 10px">
    <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName + '維護'"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-card class="box-card">
        <el-form ref="form" :model="form" :label-width="formLabelWidth">
          <el-form-item
            :label="funcName + '代碼'"
            prop="appCode"
            :rules="[{ required: true, message: '請輸入代碼', trigger: 'blur' }]"
          >
            <el-input v-model="form.appCode"></el-input>
          </el-form-item>

          <el-form-item
            :label="funcName + '名稱'"
            prop="appName"
            :rules="[{ required: true, message: '請輸入名稱', trigger: 'blur' }]"
          >
            <el-input v-model="form.appName"></el-input>
          </el-form-item>

          <el-form-item
            :label="funcName + 'IOS版號'"
            prop="appIosVer"
            :rules="[{ required: true, message: '請輸入IOS版號', trigger: 'blur' }]"
          >
            <el-input v-model="form.appIosVer"></el-input>
          </el-form-item>

          <el-form-item
            :label="funcName + 'Android版號'"
            prop="appAndroidVer"
            :rules="[{ required: true, message: '請輸入Android版號', trigger: 'blur' }]"
          >
            <el-input v-model="form.appAndroidVer"></el-input>
          </el-form-item>
        </el-form>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveData">確 定</el-button>
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true">
        <el-form-item label="查詢">
          <el-input v-model="listQuery.qry" placeholder="輸入APP名稱" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getList">查詢</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="addData">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            style="cursor: pointer"
            :loading="listLoading"
            type="success"
            icon="el-icon-refresh-left"
            circle
            @click="refresh()"
          ></el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="APP代碼" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.appName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="APP名稱" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.appName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="IOS版號" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.appIosVer }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="Android版號" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.appAndroidVer }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="建立時間" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.buildDateStr }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="建立人員" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.buildUserName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="更新時間" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.updateDateStr }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="更新人員" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.updateUserName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯" width="120">
          <template slot-scope="scope">
            <el-button type="primary" @click="editData(scope.row)">編輯</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      style="padding-top: 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'

import { getAppVersion, getAppTypeList, setAppVersion } from '@/api/travel'
var defaultForm = {
  id: null,
  appName: '',
  appDescription: '',
  appVer: '',
}

export default {
  name: 'AppVersion',
  components: {
    Pagination,
  },
  data() {
    return {
      funcName: 'App版本',
      dialogTopMargin: '5%',
      formLabelWidth: '180px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '+id',
      },
      total: 0,
      list: [],
    }
  },
  async created() {
    this.form = JSON.parse(JSON.stringify(defaultForm))
    await this.getList()
  },
  methods: {
    async refresh() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
      await this.getList()
    },
    async getAppVersion() {
      let resp = await getAppVersion({ type: groupApp })
      console.log(resp)
    },
    addData() {
      this.dialogVisible = true
    },
    editData(row) {
      this.form = row
      this.dialogVisible = true
    },
    async saveData() {
      let vm = this
      if (!confirm(`確定要儲存【${vm.funcName}}】資料?`)) {
        return
      }

      this.$refs['form'].validate(async valid => {
        if (valid) {
          vm.dialogLoading = true
          try {
            let resp = await setAppVersion(this.form)
            Message({
              message: '資料處理完成',
              type: 'success',
              duration: 5 * 1000,
            })
          } catch (error) {
            console.log(error)
          } finally {
            await vm.getList()
            this.dialogVisible = false
            vm.dialogLoading = false
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getList() {
      this.listLoading = true
      let resp = await getAppTypeList(this.listQuery)
      console.log(resp)
      this.list = resp.data.data
      this.total = resp.data.total
      this.listLoading = false
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}
</style>
